import {Button, Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React, {useEffect, useState} from 'react';
import {Arguments} from '../common/Arguments';
import {DateTimeToMoment} from '../common/MomentDateTimeConverter';
import OnFinishMethod from '../common/OnFinishMethod';
import {GetOrgData} from '../common/ApiMethod';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const EssentialInformation = () => {
	const [form] = Form.useForm();
	const [currentRecord, setCurrentRecord] = useState([]);
	const [saveButton, setSaveButton] = useState(false);
	const getApi = Arguments.host + '/society_organization/base/branch/api!branchInfo.do';
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();

	useEffect(() => {
		GetOrgData(getApi).then(finalResult => {
			form.setFieldsValue(Object.keys(finalResult).length > 0 ? DateTimeToMoment(finalResult) : finalResult);
			setCurrentRecord({organizationId: orgId, ...finalResult});
		});
	}, [getApi]);

	// 2. 只刷新一次
	useEffect(() => {
		const ALREADY_RELOAD = 'alreadyReload';
		if (!sessionStorage.getItem(ALREADY_RELOAD)) {
			sessionStorage.setItem(ALREADY_RELOAD, '1');
			setTimeout(() => window.location.reload(), 300);
		}
	}, []);

	const postApi = [Arguments.host + '/society_organization/base/branch/api!addBranchInfo.do'];

	const onFinish = (data) => {
		OnFinishMethod({...currentRecord, ...data}, postApi);
		setTimeout(() => setSaveButton(true), 500);
	};

	const onReset = () => {
		form.resetFields();
	};

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="branchName" label="支部名称" rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="branchEstablishDate" label="成立日期"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="branchTermDate" label="换届日期">
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="branchTermYear" label="换届年限"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="5">
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="branchAttribute" label="支部性质"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="独立">
						<Select>
							<Select.Option value="独立">独立</Select.Option>
							<Select.Option value="联合">联合</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit" disabled={saveButton}>
					保存
				</Button>
				<Button htmlType="button" type="danger" onClick={() => onReset()} style={{marginLeft: 8}}>
					清空
				</Button>
			</Form.Item>
		</Form>
	);
};

export default EssentialInformation;

